import React from 'react'
import "./Email.css";
export default function Email() {
  return (
    <div className='email'>
        <div className="container">
            <h2 className="email-title">
            Subscribe to our newsletter & 
We’ll give you even more to Love
            </h2>
            <p className="email-text">
            To receive exclusive offers, updates and more.
            </p>
            <form className="email-form">
                <input type="email" placeholder='Email' required className="email-input" />
                <button type='btn' className="email-btn">Sign up</button>
            </form>
        </div>
    </div>
  )
}
